import { render } from "./TranscriptPage.vue?vue&type=template&id=28ffcbae&scoped=true"
import script from "./TranscriptPage.vue?vue&type=script&lang=js"
export * from "./TranscriptPage.vue?vue&type=script&lang=js"

import "./TranscriptPage.vue?vue&type=style&index=0&id=28ffcbae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ffcbae"]])

export default __exports__